import React, { Component } from 'react';
import { uniqueId } from 'lodash';
import autoBind from 'auto-bind';
export default class RadioButtons extends Component {
	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
			id: uniqueId('RadioButtons'),
			value: this.props.initialChecked
		};
	}

	onChange(event) {
		let value = event.currentTarget.value;
		this.setState({ value });
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.value !== this.state.value &&
			typeof this.props.onChange === 'function'
		) {
			this.props.onChange(this.state.value);
		}
	}

	renderButtons() {
		return this.props.buttons.map((button, index) => {
			let key = this.state.id + '_' + index + '_' + button.value;
			return (

				<div key={key} className="cc-selector">
					{/* <input id="camera_img_radio" type="radio" name="userType" value="1" />
						<label className="drinkcard-cc userImg camera_img_radio" htmlFor="camera_img_radio"></label>
					</div> */}
					{/* {button.value == 'camera' ? <label htmlFor={key} className="drinkcard-cc userImg camera_img_radio"> */}
					{button.value == 'camera' ? <label htmlFor={key}>
					</label> : <label htmlFor={key} className="drinkcard-cc userImg share_img_radio">

						</label>}
					<input
						type="radio"
						checked={this.state.value === button.value}
						id={key}
						name={this.state.id}
						value={button.value}
						onChange={this.onChange}
					/>

				</div>
			);
		});
	}

	render() {
		return (
			<div className="btnRender">
				{this.renderButtons()}
			</div>
		);
	}
}
